import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AddressCommonService } from '../services/address-common.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { ConfigService } from 'app/core/services/config.service';

@Component({
  selector: 'itpx-phone-numbers',
  templateUrl: './phone-numbers.component.html',
  styleUrls: ['./phone-numbers.component.css']
})
export class PhoneNumbersComponent extends RxComponent implements OnInit {

    @Input()
    private phoneNumbers: any[] = [];

    @Output()
    private phoneNumbersChange = new EventEmitter<any>();

    private phoneNumberTypes: Observable<any[]>;
    private newPhoneNumber: any= {};

    constructor(
        private service: AddressCommonService,
        private configService: ConfigService
    ) { 
        super();
    }

    onPhoneTypeChange(type: any) {
        this.newPhoneNumber.type = {
            id: type.key,
            configValue: type.value
        }
    }

    onPhoneNumberAdd() {
        this.phoneNumbers.push(this.newPhoneNumber);
        this.newPhoneNumber = {};

        this.phoneNumbersChange.emit(this.phoneNumbers);
    }

    onPhoneNumberRemove(index: number) {
        if (index > -1) {
            this.phoneNumbers.splice(index, 1);
        }

        this.phoneNumbersChange.emit(this.phoneNumbers);
    }

    ngOnInit() {

        this.phoneNumberTypes = this.service.getPhoneNumberTypeDictionary();

        this.phoneNumbersChange.bindToLifecycle(this);
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/common/phone-numbers/phone-numbers.component.ts